/* global dataLayer */

/**
 * pushEvent - add event to Google Tag Manager - Data Layer
 * @param  {String} category
 * @param  {String} action
 * @param  {String} [label=undefined]
 * @param  {String} [value=undefined]
 */
export function pushEvent(category, action, label = undefined, value = undefined) {
  const eventObj = {
    event : 'GAEvent',
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    eventValue: value
  };

  dataLayer.push(eventObj);
}



// WEBPACK FOOTER //
// ../src/utils/gtagManager.js